module.exports = __webpack_public_path__ + "static/media/locationIconDark.924bd840.svg";